import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, LL_H_C, LL_V_L, Button } from '@nu-art/thunderstorm-frontend/index';
import './Base_ResolutionFunctionEditorPanel.scss';
export class Base_ResolutionFunctionEditorPanel extends ComponentSync {
    //######################### Protected #########################
    renderHeader = () => {
        return undefined;
    };
    renderBody = () => {
        return undefined;
    };
    renderButtons = () => {
        return undefined;
    };
    //######################### Privates #########################
    panelHeader = () => {
        const header = this.renderHeader();
        return _jsx("div", { className: 'resolution-function-editor-panel__header', children: header });
    };
    panelBody = () => {
        const body = this.renderBody();
        return _jsx(LL_V_L, { className: 'resolution-function-editor-panel__body', children: body });
    };
    panelButtons = () => {
        const buttons = this.renderButtons();
        return _jsxs(LL_H_C, { className: 'resolution-function-editor-panel__buttons', children: [_jsx(Button, { variant: 'tertiary', onClick: this.props.hidePanel, children: "Close" }), buttons] });
    };
    //######################### render #########################
    render() {
        return _jsxs(LL_V_L, { id: this.panelId, className: 'resolution-function-editor-panel', children: [this.panelHeader(), this.panelBody(), this.panelButtons()] });
    }
}
//# sourceMappingURL=Base_ResolutionFunctionEditorPanel.js.map